import ArticleTile from 'app/components/partials/article-tile';
import classnames from 'classnames';
import FeaturedNewsCarousel from 'app/components/partials/featured-news-carousel';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const TABS = [
    { id: 'latest', label: 'Latest' },
    { id: 'popular', label: 'Popular' }
];

// News landing hero: a carousel of featured stories beside a tabbed story list
const NewsHero = ({ featuredNews = [], latestNews = [], popularNews = [] }) => {
    const [activeTab, setActiveTab] = useState(TABS[0].id);

    if (!featuredNews.length && !latestNews.length) return null;

    const itemsByTab = {
        latest: latestNews,
        popular: popularNews
    };
    const activeItems = itemsByTab[activeTab] || [];

    // The list stands in a box tall enough for the fuller of the two tabs, so
    // switching tabs leaves the height of the row where it is. The stylesheet
    // turns the count into a height.
    const reservedCards = Math.max(latestNews.length, popularNews.length);

    return (
        <section className="news-hero">
            <div className="constrain-width large">
                <div className="tile-grid">
                    <div className="news-hero-feature">
                        <FeaturedNewsCarousel items={featuredNews} />
                    </div>
                    <div className="tile-grid-sidebar">
                        <div className="tile-grid-sidebar-inner">
                            <div className="news-hero-tabs" role="tablist">
                                {TABS.map(({ id, label }) => (
                                    <button
                                        key={id}
                                        className={classnames('tab', { 'is-selected': id === activeTab })}
                                        role="tab"
                                        aria-selected={id === activeTab}
                                        onClick={() => setActiveTab(id)}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                            <div className="news-highlight" style={{ '--news-hero-cards': reservedCards }}>
                                {activeItems.length > 0 ?
                                    activeItems.map((item, index) => <ArticleTile key={index} item={item} />) :
                                    <p className="news-hero-empty">No stories to show yet.</p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

NewsHero.propTypes = {
    featuredNews: PropTypes.array,
    latestNews: PropTypes.array,
    popularNews: PropTypes.array
};

export default NewsHero;
